import { render, staticRenderFns } from "./landing-texts.vue?vue&type=template&id=0469432a"
import script from "./landing-texts.vue?vue&type=script&lang=ts"
export * from "./landing-texts.vue?vue&type=script&lang=ts"
import style0 from "./landing-texts.vue?vue&type=style&index=0&id=0469432a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports